import { useEffect } from 'react';

import { useHasEditorContentChanged } from '@confluence/editor-features/entry-points/useHasEditorContentChanged';
import { useLivePageEditExperience } from '@confluence/live-pages-features/entry-points/useLivePageEditExperience';
import type { FullPageEditorPresetAPI } from '@confluence/editor-presets/entry-points/useFullPageEditorPreset';
import { useFullPageEditorApiActions } from '@confluence/full-page-editor-store';

// This is used to start the edit page experience when the user makes a change on live pages. Normal pages edit-page experience is still started by startExperienceForRoute.ts
// The useLivePageEditExperience hook in live-page-features package is responsible for providing the function to start the specific experience only on a live page and once per contentId
// This FullPageEditorComponent is responsible for starting it only if certain editor/page features are set (editorApi + local editor change made).
export function useStartLivePageEditExperience({
	editorApi,
	contentId,
}: {
	editorApi?: FullPageEditorPresetAPI;
	contentId: string;
}) {
	const startLivePageEditExperience = useLivePageEditExperience({ contentId });
	const { hasEditorContentChangedByLocalUserExcludingComments } = useHasEditorContentChanged({
		editorPresetAPI: editorApi,
	});
	const { setEditorApi } = useFullPageEditorApiActions();

	useEffect(() => {
		if (editorApi) {
			// FIXME: https://product-fabric.atlassian.net/browse/ED-25722
			// @ts-expect-error
			void setEditorApi(editorApi);
		}
	}, [editorApi, setEditorApi]);

	useEffect(() => {
		if (editorApi && hasEditorContentChangedByLocalUserExcludingComments) {
			startLivePageEditExperience();
		}
	}, [editorApi, startLivePageEditExperience, hasEditorContentChangedByLocalUserExcludingComments]);
}
